import { useTranslation } from 'react-i18next';

import { setLocale, SUPPORTED_LOCALES, type SupportedLocale } from '@/locales/i18n';

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  return (
    <div className="inline-flex rounded-lg border border-slate-200 bg-white p-0.5 text-xs">
      {SUPPORTED_LOCALES.map((lng) => {
        const active = i18n.language?.startsWith(lng);
        return (
          <button
            key={lng}
            type="button"
            onClick={() => setLocale(lng as SupportedLocale)}
            className={`rounded-md px-2 py-1 font-medium uppercase ${
              active ? 'bg-brand text-white' : 'text-slate-600 hover:bg-slate-100'
            }`}
          >
            {lng}
          </button>
        );
      })}
    </div>
  );
}
